export default __webpack_public_path__ + "static/media/copy.c37efded.svg";